var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import jwt_decode from "jwt-decode";
import { getAccountCodeFromToken, getEmailFromToken, getIsImpersonatedFromToken, getIsInIFrame, getLgSrc, salesGetEmployeeCode, getaccTypeFromToken, } from "./tokenParser";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import { ILoginTypeEnum } from "@domains/salesFeatures/Login/entities/iLogin";
import { EUserRole } from "@domains/features/ActivityBook/OrderBook/MutualFund/entities/IGetMFOrderbookSummaryEntity";
var AccountDetails = /** @class */ (function () {
    function AccountDetails(localStorage, cookieStorage, sessionStorage) {
        this.localStorage = localStorage;
        this.cookieStorage = cookieStorage;
        this.sessionStorage = sessionStorage;
    }
    AccountDetails.prototype.getAccountCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getParsedAccountCode()];
            });
        });
    };
    AccountDetails.prototype.getPreferedAccountCodeID = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage.get("acc_data").then(function (data) {
                            var accData = data ? JSON.parse(data) : null;
                            var calculatedAccCode = (accData === null || accData === void 0 ? void 0 : accData.accTyp) === "COMEQ"
                                ? (accData === null || accData === void 0 ? void 0 : accData.prefAccTyp) === "EQ"
                                    ? accData === null || accData === void 0 ? void 0 : accData.eqAccID
                                    : accData === null || accData === void 0 ? void 0 : accData.coAccID
                                : (accData === null || accData === void 0 ? void 0 : accData.accTyp) === "EQ"
                                    ? accData === null || accData === void 0 ? void 0 : accData.eqAccID
                                    : accData === null || accData === void 0 ? void 0 : accData.coAccID;
                            var accTyp = (accData === null || accData === void 0 ? void 0 : accData.accTyp) === "COMEQ"
                                ? (accData === null || accData === void 0 ? void 0 : accData.prefAccTyp)
                                    ? accData === null || accData === void 0 ? void 0 : accData.prefAccTyp
                                    : "EQ"
                                : accData === null || accData === void 0 ? void 0 : accData.accTyp;
                            return { accCode: calculatedAccCode, accTyp: accTyp };
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getPrfAccTyp = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage.get("acc_data").then(function (data) {
                            var accData = data ? JSON.parse(data) : null;
                            var accTyp = (accData === null || accData === void 0 ? void 0 : accData.accTyp) === "COMEQ"
                                ? (accData === null || accData === void 0 ? void 0 : accData.prefAccTyp)
                                    ? accData === null || accData === void 0 ? void 0 : accData.prefAccTyp
                                    : "EQ"
                                : accData === null || accData === void 0 ? void 0 : accData.accTyp;
                            return accTyp;
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getmfInf = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.accs.mfInf;
                        })
                            .catch(function (err) {
                            return false;
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getParsedAccountCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var inIframe;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        inIframe = getIsInIFrame();
                        if (!inIframe) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accCodeFromJwtToken()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.accTyp === "EQ"
                                ? jsonObj.accs.eqAccID
                                    ? jsonObj.accs.eqAccID
                                    : jsonObj.eqAccID
                                : jsonObj.accs.coAccID
                                    ? jsonObj.accs.coAccID
                                    : jsonObj.coAccID;
                        })
                            .catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.accCodeFromJwtToken()];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); })];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getCipFlag = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, jwtToken, _c, decoded_token, e_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.localStorage.get("isImpersonated")];
                    case 1:
                        if (!_d.sent()) return [3 /*break*/, 3];
                        _b = (_a = JSON).parse;
                        return [4 /*yield*/, this.localStorage.get("isImpersonated")];
                    case 2: return [2 /*return*/, _b.apply(_a, [_d.sent()])];
                    case 3: return [4 /*yield*/, this.cookieStorage.get("jwt_token")];
                    case 4:
                        if (!(_d.sent())) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.cookieStorage.get("jwt_token")];
                    case 5:
                        _c = _d.sent();
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, this.localStorage.get("jwt_token")];
                    case 7:
                        _c = _d.sent();
                        _d.label = 8;
                    case 8:
                        jwtToken = _c;
                        if (!jwtToken) return [3 /*break*/, 13];
                        _d.label = 9;
                    case 9:
                        _d.trys.push([9, 11, , 12]);
                        return [4 /*yield*/, jwt_decode(jwtToken)];
                    case 10:
                        decoded_token = _d.sent();
                        return [2 /*return*/, decoded_token
                                ? getIsImpersonatedFromToken(decoded_token)
                                : false];
                    case 11:
                        e_1 = _d.sent();
                        return [2 /*return*/, false];
                    case 12: return [3 /*break*/, 14];
                    case 13: return [2 /*return*/, false];
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    AccountDetails.prototype.getLoginSrc = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jwtToken, _a, decoded_token, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.cookieStorage.get("jwt_token")];
                    case 1:
                        if (!(_b.sent())) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.cookieStorage.get("jwt_token")];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.localStorage.get("jwt_token")];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        jwtToken = _a;
                        if (!jwtToken) return [3 /*break*/, 10];
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, jwt_decode(jwtToken)];
                    case 7:
                        decoded_token = _b.sent();
                        return [2 /*return*/, decoded_token ? getLgSrc(decoded_token) : ""];
                    case 8:
                        e_2 = _b.sent();
                        return [2 /*return*/, ""];
                    case 9: return [3 /*break*/, 11];
                    case 10: return [2 /*return*/, ""];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    AccountDetails.prototype.isNonPoaClient = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.accs.cdslAuToSl;
                        })
                            .catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
                            var _a, _b, _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0: return [4 /*yield*/, this.cookieStorage.get("isNonPOA")];
                                    case 1:
                                        if (!(_d.sent())) return [3 /*break*/, 3];
                                        _c = (_b = JSON).parse;
                                        return [4 /*yield*/, this.cookieStorage.get("isNonPOA")];
                                    case 2:
                                        _a = _c.apply(_b, [_d.sent()]);
                                        return [3 /*break*/, 4];
                                    case 3:
                                        _a = false;
                                        _d.label = 4;
                                    case 4: return [2 /*return*/, _a];
                                }
                            });
                        }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getEmailId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (getIsInIFrame())
                            return [2 /*return*/, this.getEmailFromJWTToken()];
                        return [4 /*yield*/, this.localStorage
                                .get("acc_data")
                                .then(function (data) {
                                return JSON.parse(data);
                            })
                                .then(function (jsonObj) {
                                return jsonObj.accs.eml ? jsonObj.accs.eml : "";
                            })
                                .catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, this.getEmailFromJWTToken()];
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getAccTyp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            if (data)
                                return JSON.parse(data);
                            return Promise.reject("acc_data not found");
                            if (data)
                                return JSON.parse(data);
                            return Promise.reject("acc_data not found");
                        })
                            .then(function (jsonObj) {
                            return (jsonObj === null || jsonObj === void 0 ? void 0 : jsonObj.accTyp) || (jsonObj === null || jsonObj === void 0 ? void 0 : jsonObj.accTyp);
                        })
                            .catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
                            var jwtToken, decoded_token, e_3;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.getJWTToken()];
                                    case 1:
                                        jwtToken = _a.sent();
                                        if (!jwtToken) return [3 /*break*/, 6];
                                        _a.label = 2;
                                    case 2:
                                        _a.trys.push([2, 4, , 5]);
                                        return [4 /*yield*/, jwt_decode(jwtToken)];
                                    case 3:
                                        decoded_token = _a.sent();
                                        return [2 /*return*/, decoded_token ? getaccTypeFromToken(decoded_token) : ""];
                                    case 4:
                                        e_3 = _a.sent();
                                        return [2 /*return*/, ""];
                                    case 5: return [3 /*break*/, 7];
                                    case 6: return [2 /*return*/, ""];
                                    case 7: return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getUserID = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.userID || jsonObj.userId;
                        })
                            .catch(function (err) {
                            return _this.getNameFromJwtToken();
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getEmpOrDependent = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            var _a;
                            return (_a = jsonObj === null || jsonObj === void 0 ? void 0 : jsonObj.accs) === null || _a === void 0 ? void 0 : _a.empOrDependent;
                        })
                            .catch(function (err) {
                            return "";
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getProductsAlias = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj === null || jsonObj === void 0 ? void 0 : jsonObj.productsAlias;
                        })
                            .catch(function (err) {
                            return "";
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getPhoneNo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.mrgAccDts.phNos || jsonObj.accs.mobile;
                        })
                            .catch(function (err) {
                            return [];
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getAccPhoneNo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.accs.mobile;
                        })
                            .catch(function (err) {
                            return [];
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getEqAccName = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.accs.eqAccName;
                        })
                            .catch(function (err) {
                            return "";
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getCoAccName = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.accs.coAccName;
                        })
                            .catch(function (err) {
                            return "";
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getProducts = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.prds;
                        })
                            .catch(function (err) {
                            return [];
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getOrderTypes = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.ordTypes;
                        })
                            .catch(function (err) {
                            return [];
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getValidity = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.val;
                        })
                            .catch(function (err) {
                            return [];
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getpanAadhaarLinked = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.panAadhaarLinked === "true";
                        })
                            .catch(function (err) {
                            return null;
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.prefAccTyp = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.prefAccTyp;
                        })
                            .catch(function (err) {
                            return "";
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.eqAccID = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.eqAccID;
                        })
                            .catch(function (err) {
                            return "";
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.coAccID = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.coAccID;
                        })
                            .catch(function (err) {
                            return "";
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getAccountMrgSts = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.mrgSts;
                        })
                            .catch(function (err) {
                            return null;
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getPrfid = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.accs.prfId;
                        })
                            .catch(function (err) {
                            return null;
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getGuestId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("guest_acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj.guestId;
                        })
                            .catch(function (err) {
                            return null;
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.isUserLoggedIn = function () {
        var userLoggedIn = false;
        var jwtToken = window.localStorage.getItem("jwt_token");
        if (jwtToken !== undefined && jwtToken !== null && jwtToken !== "") {
            userLoggedIn = true;
        }
        else
            userLoggedIn = false;
        return userLoggedIn;
    };
    AccountDetails.prototype.getAccData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorage
                            .get("acc_data")
                            .then(function (data) {
                            return JSON.parse(data);
                        })
                            .then(function (jsonObj) {
                            return jsonObj;
                        })
                            .catch(function (err) {
                            return null;
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AccountDetails.prototype.getSalesEmployeeCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var salesAccessToken, _a, decoded_token;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.localStorage.get(ELocalStorageKeys.AccessToken)];
                    case 1:
                        if (!(_b.sent())) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.localStorage.get(ELocalStorageKeys.AccessToken)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.cookieStorage.get(ELocalStorageKeys.AccessToken)];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        salesAccessToken = _a;
                        if (salesAccessToken) {
                            try {
                                decoded_token = jwt_decode(salesAccessToken);
                                return [2 /*return*/, decoded_token ? salesGetEmployeeCode(decoded_token) : ""];
                            }
                            catch (e) {
                                return [2 /*return*/, ""];
                            }
                        }
                        else {
                            return [2 /*return*/, ""];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountDetails.prototype.getSalesuserId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var salesAccessToken, _a, decoded_token, e_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.localStorage.get(ELocalStorageKeys.AccessToken)];
                    case 1:
                        if (!(_b.sent())) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.localStorage.get(ELocalStorageKeys.AccessToken)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.cookieStorage.get(ELocalStorageKeys.AccessToken)];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        salesAccessToken = _a;
                        if (!salesAccessToken) return [3 /*break*/, 10];
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, jwt_decode(salesAccessToken)];
                    case 7:
                        decoded_token = _b.sent();
                        return [2 /*return*/, decoded_token ? decoded_token.userId : ""];
                    case 8:
                        e_4 = _b.sent();
                        return [2 /*return*/, ""];
                    case 9: return [3 /*break*/, 11];
                    case 10: return [2 /*return*/, ""];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    AccountDetails.prototype.getEmployeeCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var salesAccessToken, _a, decoded_token, e_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.localStorage.get("access_token")];
                    case 1:
                        if (!(_b.sent())) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.localStorage.get("access_token")];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.cookieStorage.get("access_token")];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        salesAccessToken = _a;
                        if (!salesAccessToken) return [3 /*break*/, 10];
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, jwt_decode(salesAccessToken)];
                    case 7:
                        decoded_token = _b.sent();
                        return [2 /*return*/, decoded_token ? decoded_token.employeeCode : ""];
                    case 8:
                        e_5 = _b.sent();
                        return [2 /*return*/, ""];
                    case 9: return [3 /*break*/, 11];
                    case 10: return [2 /*return*/, ""];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    AccountDetails.prototype.getSalesloginId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var salesAccessToken, _a, decoded_token, e_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.localStorage.get("access_token")];
                    case 1:
                        if (!(_b.sent())) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.localStorage.get("access_token")];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.cookieStorage.get("access_token")];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        salesAccessToken = _a;
                        if (!salesAccessToken) return [3 /*break*/, 10];
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, jwt_decode(salesAccessToken)];
                    case 7:
                        decoded_token = _b.sent();
                        return [2 /*return*/, decoded_token ? decoded_token.loginId : ""];
                    case 8:
                        e_6 = _b.sent();
                        return [2 /*return*/, ""];
                    case 9: return [3 /*break*/, 11];
                    case 10: return [2 /*return*/, ""];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    AccountDetails.prototype.getSalesEmpName = function () {
        return __awaiter(this, void 0, void 0, function () {
            var salesAccessToken, _a, decoded_token, e_7;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.localStorage.get(ELocalStorageKeys.AccessToken)];
                    case 1:
                        if (!(_b.sent())) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.localStorage.get(ELocalStorageKeys.AccessToken)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.cookieStorage.get(ELocalStorageKeys.AccessToken)];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        salesAccessToken = _a;
                        if (!salesAccessToken) return [3 /*break*/, 10];
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, jwt_decode(salesAccessToken)];
                    case 7:
                        decoded_token = _b.sent();
                        return [2 /*return*/, decoded_token ? decoded_token.employeeName : ""];
                    case 8:
                        e_7 = _b.sent();
                        return [2 /*return*/, ""];
                    case 9: return [3 /*break*/, 11];
                    case 10: return [2 /*return*/, ""];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    AccountDetails.prototype.getSalesAuthToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var salesAccessToken, _a, decoded_token, e_8;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.localStorage.get(ELocalStorageKeys.AccessToken)];
                    case 1:
                        if (!(_b.sent())) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.localStorage.get(ELocalStorageKeys.AccessToken)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.cookieStorage.get(ELocalStorageKeys.AccessToken)];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        salesAccessToken = _a;
                        if (!salesAccessToken) return [3 /*break*/, 10];
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, jwt_decode(salesAccessToken)];
                    case 7:
                        decoded_token = _b.sent();
                        return [2 /*return*/, decoded_token ? decoded_token.authToken : ""];
                    case 8:
                        e_8 = _b.sent();
                        return [2 /*return*/, ""];
                    case 9: return [3 /*break*/, 11];
                    case 10: return [2 /*return*/, ""];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    AccountDetails.prototype.getJWTToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var inIframe, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        inIframe = getIsInIFrame();
                        if (!inIframe) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.localStorage.get("sales_jwt_token")];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2:
                        _c.trys.push([2, 8, , 9]);
                        return [4 /*yield*/, this.cookieStorage.get("jwt_token")];
                    case 3:
                        if (!(_c.sent())) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.cookieStorage.get("jwt_token")];
                    case 4:
                        _a = _c.sent();
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this.localStorage.get("jwt_token")];
                    case 6:
                        _a = _c.sent();
                        _c.label = 7;
                    case 7: return [2 /*return*/, _a];
                    case 8:
                        _b = _c.sent();
                        return [2 /*return*/, ""];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    AccountDetails.prototype.getNameFromJwtToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jwtToken, decoded_token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJWTToken()];
                    case 1:
                        jwtToken = _a.sent();
                        if (jwtToken) {
                            try {
                                decoded_token = jwt_decode(jwtToken);
                                return [2 /*return*/, decoded_token ? decoded_token.username : ""];
                            }
                            catch (e) {
                                return [2 /*return*/, ""];
                            }
                        }
                        else {
                            return [2 /*return*/, ""];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountDetails.prototype.accCodeFromJwtToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jwtToken, decoded_token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJWTToken()];
                    case 1:
                        jwtToken = _a.sent();
                        if (jwtToken) {
                            try {
                                decoded_token = jwt_decode(jwtToken);
                                return [2 /*return*/, decoded_token ? getAccountCodeFromToken(decoded_token) : ""];
                            }
                            catch (e) {
                                return [2 /*return*/, ""];
                            }
                        }
                        else {
                            return [2 /*return*/, ""];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountDetails.prototype.getEmailFromJWTToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jwtToken, decoded_token, e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getJWTToken()];
                    case 1:
                        jwtToken = _a.sent();
                        return [4 /*yield*/, jwt_decode(jwtToken)];
                    case 2:
                        decoded_token = _a.sent();
                        return [2 /*return*/, getEmailFromToken(decoded_token)];
                    case 3:
                        e_9 = _a.sent();
                        return [2 /*return*/, ""];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AccountDetails.prototype.getUserLoginCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var loginType, userLoginCode, _a, e_10;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        loginType = localStorage.getItem(ELocalStorageKeys.LoginType);
                        if (!(loginType == ILoginTypeEnum.PARTNER)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getSalesloginId()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.getEmployeeCode()];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        userLoginCode = _a;
                        return [2 /*return*/, userLoginCode];
                    case 5:
                        e_10 = _b.sent();
                        return [2 /*return*/, ""];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AccountDetails.prototype.getUserLoginType = function () {
        return __awaiter(this, void 0, void 0, function () {
            var loginType, userLoginType;
            return __generator(this, function (_a) {
                try {
                    loginType = localStorage.getItem(ELocalStorageKeys.LoginType);
                    userLoginType = loginType == ILoginTypeEnum.PARTNER ? EUserRole.PARTNER : EUserRole.RM;
                    return [2 /*return*/, userLoginType];
                }
                catch (e) {
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    AccountDetails.prototype.getLoggedInUserAccountDetailsFromTokenInSalesJourney = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var salesAccessToken, _b, decoded_token, e_11;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.localStorage.get(ELocalStorageKeys.AccessToken)];
                    case 1:
                        if (!((_a = (_c.sent())) !== null && _a !== void 0)) return [3 /*break*/, 2];
                        _b = _a;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.cookieStorage.get(ELocalStorageKeys.AccessToken)];
                    case 3:
                        _b = (_c.sent());
                        _c.label = 4;
                    case 4:
                        salesAccessToken = _b;
                        if (!salesAccessToken) return [3 /*break*/, 9];
                        _c.label = 5;
                    case 5:
                        _c.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, jwt_decode(salesAccessToken)];
                    case 6:
                        decoded_token = _c.sent();
                        return [2 /*return*/, decoded_token ? decoded_token : undefined];
                    case 7:
                        e_11 = _c.sent();
                        return [2 /*return*/, undefined];
                    case 8: return [3 /*break*/, 10];
                    case 9: return [2 /*return*/, undefined];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    return AccountDetails;
}());
export { AccountDetails };
